export default __webpack_public_path__ + "static/media/starts.f5bc7d3c.svg";